import { DialogTitle, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Flex } from "~/components/Flex";
import { pluralize } from "~/lib/pluralize";
import { AttachIcon } from "~/icons";

type CaseModalTitleProps = { onClose: () => void; assetsCount?: number };

export const CreateTicketModalTitle = ({
  onClose,
  assetsCount,
}: CaseModalTitleProps) => {
  return (
    <DialogTitle
      component="div"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 5,
        pb: 2,
      }}
    >
      <Flex sx={{ alignItems: "center" }} gap={2}>
        <AttachIcon />
        <Typography
          variant="h5"
          sx={{
            textTransform: "uppercase",
            fontWeight: "700",
          }}
        >
          Create New Ticket
          {assetsCount
            ? ` for ${assetsCount} ${pluralize("asset", assetsCount)}`
            : ""}
        </Typography>
      </Flex>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};
